import StoreGet from './Get'
import StoreCreate from './Create'
import StoreUpdate from './Update'
import StoreCoupon from './Coupon'
import StoreCoupons from './GetCoupon'
// import StoreDetails from './Details'

export {
    StoreGet,
    StoreCreate,
    StoreUpdate,
    StoreCoupon,
    StoreCoupons
    // StoreDetails,
}